import { HttpClient } from "@angular/common/http";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var OrganizationService = /** @class */ (function () {
    function OrganizationService(_httpClient) {
        this._httpClient = _httpClient;
    }
    OrganizationService.prototype.loadOrganization = function (organizationId) {
        return this._httpClient.get("api/organizations/" + organizationId).toPromise();
    };
    OrganizationService.prototype.submitLicenseRequest = function (organization) {
        return this._httpClient.post("api/licenseRequests", organization).toPromise();
    };
    OrganizationService.ngInjectableDef = i0.defineInjectable({ factory: function OrganizationService_Factory() { return new OrganizationService(i0.inject(i1.HttpClient)); }, token: OrganizationService, providedIn: "root" });
    return OrganizationService;
}());
export { OrganizationService };
